<template>
  <div class="locale-switcher">
    <v-select :items="locales" v-model="$i18n.locale">
      <template slot="prepend">
        <v-icon>mdi-earth</v-icon>
      </template>
    </v-select>
  </div>
</template>

<script>
import { getSupportedLocales } from "../i18n/supported-locales";
export default {
  data: () => ({
    locales: getSupportedLocales(),
  }),
};
</script>